<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"><g style="stroke:#d2d3d6;fill:#fff"><circle cx="18" cy="18" r="18" stroke="none" style="stroke:none"/><circle cx="18" cy="18" r="17.5" style="fill:none"/></g><path d="M4 10 0 5l4-5" style="stroke:currentColor;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;fill:none" transform="translate(15.5 13)" fill="currentColor"/><path d="M0 0h9" style="stroke:currentColor;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;fill:none" transform="translate(17 18)" fill="currentColor"/><path d="M0 0v11" style="stroke:currentColor;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;fill:none" transform="translate(12.5 12.5)" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-lnb-close',
});
</script>
